import React from 'react'

import FieldRAG_Icon from "../rag-icon"

export default function FieldRAG_InlineValueEmpty(props:any) {
    return (
        <React.Fragment>
            <div className={Classes("ui5-txt-no-accent-default ui5-field-dropdown-inline-editable min-w-125", props.className)} onClick={props.onClick}>
                <FieldRAG_Icon className="fl-ac"/>
            </div>
            {props.children}
        </React.Fragment>
    )
}